import React from "react"
import style from "./ImageTextSection.module.scss"
import cs from "classnames"

interface Props {
  className?: string
  textClassName?: string
  mediaContent: React.ReactNode
  title: React.ReactNode
  content: React.ReactNode
}

const ImageTextSection = ({ className, textClassName, mediaContent, title, content }: Props) => {
  return (
    <div className={cs(style.container, className)}>
      <div className={textClassName}>
        {title}
        {content}
      </div>
      <div className={style.imageContainer}>{mediaContent}</div>
    </div>
  )
}

export default ImageTextSection
